import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import {
  setDischargeField,
  addDischargeArrayItem,
  removeDischargeArrayItem,
} from "../../../../Redux/actions/dischargeActions";
import DischargeService from "../../../../Services/DischargeService";

const MASTER_PAYLOAD = { activeYn: "Y", pageNo: 1, pageSize: 30 };

export default function PatientInstructions() {
  const dispatch = useDispatch();
  const selectedInstructions = useSelector(
    (state) => state.discharge?.dischargePatientInstruction || []
  );
  const additionalInstruction = useSelector(
    (state) => state.discharge?.additionalInstruction || ""
  );

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    DischargeService.GetDischargePatientInstructionMaster(MASTER_PAYLOAD)
      .then((res) => {
        const data = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.data?.data)
          ? res.data.data
          : [];
        setOptions(data);
      })
      .catch((err) => console.error("PatientInstructions fetch error:", err))
      .finally(() => setLoading(false));
  }, []);

  const isChecked = (instrCode) =>
    selectedInstructions.some((item) => item.instrCode === instrCode);

  const handleToggleInstruction = (instr) => {
    const code = instr.instrCode || instr.code || instr.id;
    const name = instr.instrName || instr.name || instr.description || "";
    const existingIndex = selectedInstructions.findIndex(
      (item) => item.instrCode === code
    );
    if (existingIndex > -1) {
      dispatch(removeDischargeArrayItem("dischargePatientInstruction", existingIndex));
    } else {
      dispatch(
        addDischargeArrayItem("dischargePatientInstruction", {
          instructionId: selectedInstructions.length + 1,
          instrCode: code,
          instrName: name,
          status: 1,
        })
      );
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-2 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        9. Patient Instructions ({selectedInstructions.length} Selected)
      </h3>
      <label className="block text-xs font-semibold mb-2 text-gray-700">
        Standard Instructions
      </label>

      {loading && (
        <div className="flex items-center gap-2 py-3 text-[12px] text-gray-400">
          <FaSpinner className="animate-spin" /> Loading instructions...
        </div>
      )}

      {!loading && options.length === 0 && (
        <p className="text-[12px] text-gray-400 italic py-2">No instructions available.</p>
      )}

      {!loading && options.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2.5 gap-x-3 mb-3 text-xs font-medium text-gray-700">
          {options.map((instr) => {
            const code = instr.instrCode || instr.code || instr.id;
            const name = instr.instrName || instr.name || instr.description || "";
            const checked = isChecked(code);
            return (
              <label
                key={code}
                className="flex items-center gap-2 cursor-pointer hover:text-teal-800 transition"
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => handleToggleInstruction(instr)}
                  className="rounded text-teal-600 focus:ring-teal-500"
                />
                <span className={checked ? "text-teal-900 font-semibold" : ""}>
                  {name}
                </span>
              </label>
            );
          })}
        </div>
      )}

      <div>
        <label className="block text-xs font-semibold mb-1 text-gray-700">
          Additional Instructions
        </label>
        <input
          type="text"
          value={additionalInstruction}
          onChange={(e) =>
            dispatch(setDischargeField("additionalInstruction", e.target.value))
          }
          className="w-full text-xs border border-gray-200 rounded-md px-3 py-2 outline-none focus:border-teal-500 transition"
          placeholder="e.g. Maintain adequate hydration and follow the prescribed medication schedule."
        />
      </div>
    </div>
  );
}

